module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABUUlEQVRYhcXXQUcEYRzH8a+NTl0SG6VD6tR130DHOqXjXoaUEq2KRDo0kUhEIlFd9rLsYU8dYy517tKrqOgNxHbYZzLG7GP+/J7pz98zzHg+v+fheRiopiIgcR1VZP5VDPRzHf8nXlkIH5725kjAAB/AIlD3fDMVAm4CXfe8ALwzfAcSNR5lJi8TQnoiNgoAX4hYiW8X4L4QUnzXgxeFkOIHJfB8CFkdGfA+0FHiJ0a8rcTPjPiDEr8w4rdK/MqIXyvxGyN+qcTvjPi5En804rESbxvxYyXeMeKHKnjCjV0Dvq/CAdaAOUOIHSUO0APegJkSIbbUeAP4cZO/ApOeEOtqHOA0hzwD4wUhgvxY1BhsfX6lT8BYJkQzBA6wWoCn3QNGQ8E1N64Mef8FfANLoQIAzDoku+oXBpfLfEg4rT2HfgL3wHIVaLYSoAVMVw0D/AKOHBHmadxLpgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/笔 (2)(1).png
// module id = yNO+
// module chunks = 1